<template>
  <div>
    <b-container fluid class="psnl">
      <b-row>
        <b-col class="center">
          <b-img
            :src="mobileHomeInfo.PictureUrl"
            fluid
            alt="user-img"
            onerror="javascript:this.src='../static/img/avatar-default.jpg'"
          ></b-img>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="pname">{{mobileHomeInfo.FirstNameWithoutMiddle}} {{mobileHomeInfo.LastName}}</b-col>
      </b-row>
      <b-row>
        <b-col class="center">
          <QRCode :URL="salseQRCode" :QRCodeWidth="150" class="qr"></QRCode>
        </b-col>
      </b-row>
    </b-container>

    <b-container fluid class="anns">
      <b-row class="annslist">
        <b-col class="tag">邀請碼</b-col>
        <b-col class="ctn">邀請你的親朋好友用手機拍攝QR Code，成為你的SCRM好友！</b-col>
      </b-row>
      <!-- <b-row class="annslist">
        <b-col class="tag">獎勵名單</b-col>
        <b-col class="date">2019/01/10</b-col>
        <b-col class="ctn">賀! 名單積分匹配全面導入客戶主聯，業務同仁每日可取得3筆獎勵名單。</b-col>
      </b-row>
      <b-row class="annslist">
        <b-col class="tag">經驗值積分</b-col>
        <b-col class="date">2018/08/15</b-col>
        <b-col class="ctn">新增名單轉派加減分，轉出業務扣除成交積分2分，承接名單之業務則補回2分，故轉出方扣2分，轉入方加2分。</b-col>
      </b-row>
      <b-row class="annslist">
        <b-col class="tag">獎勵名單</b-col>
        <b-col class="date">2018/08/01</b-col>
        <b-col class="ctn">
          <b>每日結算排名獎勵</b>，前五名可獲得額外獎勵名單，排名首位可獲得
          <span>5</span>筆獎勵名單，排名第二則是4筆獎勵名單，依排名順序遞減。
        </b-col>
      </b-row>
      <b-row class="annslist">
        <b-col class="tag">經驗值積分</b-col>
        <b-col class="date">2018/07/31</b-col>
        <b-col class="ctn">
          系統於每月一號，將進行積分重置，
          <b>重置後積分排名不變動</b>，積分差距會縮小，期許本月積分落後者，次月能迎頭趕上。
        </b-col>
      </b-row>
      <b-row class="annslist">
        <b-col class="tag">經驗值積分</b-col>
        <b-col class="date">2018/07/02</b-col>
        <b-col class="ctn">
          系統新上線，送
          <span>1</span> 筆獎勵名單。
        </b-col>
      </b-row> -->
    </b-container>
  </div>
</template>

<script>
import QRCode from "../Main/QRCode.vue";
export default {
  props: ["mobileHomeInfo", "salseQRCode", "tutorChatToken"],
  components: {
    QRCode
  },
  data() {
    return {};
  }
};
</script>

<style scoped>
.img-fluid {
  width: 120px;
  height: 120px;
  border-radius: 50%;
}

.pname {
  text-align: center;
  line-height: 44px;
  color: #555;
  font-size: 18px;
  font-weight: bold;
}
.center {
  text-align: center;
}

.psnl {
  margin-bottom: 30px;
}
.qr canvas {
  border: 2px solid #fff;
}

.qr {
  margin-top: 15px;
}

.annslist {
  position: relative;
  display: block;
  margin-bottom: 20px;
  padding-bottom: 60px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  background: #fff;
}
.annslist:last-child {
  margin-bottom: 0;
  border-bottom: none;
}

.tag {
  position: absolute;
  color: #c60000;
  padding: 2px 10px 0;
  font-size: 14px;
  top: 14px;
  left: -1px;
  border-left: 5px solid #c60000;
  font-weight: bold;
}

.date {
  position: absolute;
  left: 0;
  top: 15px;
  font-size: 13px;
  color: #999;
  letter-spacing: 1px;
  text-align: right;
}
.ctn {
  position: relative;
  top: 45px;
  font-size: 13px;
  color: #555;
  text-align: justify;
  line-height: 20px;
}

.anns {
  max-width: 1140px;
}
</style>


// WEBPACK FOOTER //
// src/components/Mobile/MobileHome.vue